/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Chars_TitleInputs */

const en_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Character count warning: character count is above max value`)
};

const fr_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerte caractères : le nombre de caractères dépasse la valeur maximale`)
};

const de_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warnung wegen zu hoher Zeichenanzahl: Die maximale Zeichenanzahl wurde überschritten.`)
};

const it_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avviso sul conteggio dei caratteri: il conteggio dei caratteri è superiore al valore massimo`)
};

const ru_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предупреждение о превышении лимита символов: количество символов превышает максимально допустимое значение.`)
};

const es_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertencia de conteo de caracteres: el conteo de caracteres supera el valor máximo`)
};

const zh_cn2_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字符数警告：字符数已超过最大值`)
};

const ja_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字数警告: 文字数が最大値を超えています`)
};

const hi_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्णों की संख्या संबंधी चेतावनी: वर्णों की संख्या अधिकतम मान से अधिक है`)
};

const pt_pt2_event_warning_chars_title = /** @type {(inputs: Event_Warning_Chars_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso sobre o limite de caracteres: o número de caracteres está acima do valor máximo permitido.`)
};

/**
* | output |
* | --- |
* | "Character count warning: character count is above max value" |
*
* @param {Event_Warning_Chars_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_chars_title = /** @type {((inputs?: Event_Warning_Chars_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Chars_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_chars_title(inputs)
	if (locale === "de") return de_event_warning_chars_title(inputs)
	if (locale === "it") return it_event_warning_chars_title(inputs)
	if (locale === "ru") return ru_event_warning_chars_title(inputs)
	if (locale === "es") return es_event_warning_chars_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_chars_title(inputs)
	if (locale === "ja") return ja_event_warning_chars_title(inputs)
	if (locale === "hi") return hi_event_warning_chars_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_chars_title(inputs)
	return en_event_warning_chars_title(inputs)
});